<rek-headered-page 
  [header]="'SHARED.LOGIN.WAIT-FOR-LOGIN-REDIRECT-HEADER' | translate" 
  [headeredPageType]="HeaderedPageType.LARGE_PADDING">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <p *ngIf="failureMessage">
        {{ failureMessage }}
      </p>

      <rek-spinner *ngIf="!failureMessage && !isLoginCallback" [text]="'SHARED.LOGIN.WAIT-FOR-LOGIN-REDIRECT' | translate"></rek-spinner>
      <rek-spinner *ngIf="!failureMessage && isLoginCallback" [text]="'SHARED.LOGIN.WAIT-AFTER-REDIRECT' | translate"></rek-spinner>
    </div>
  </div>
</rek-headered-page>